import { useLocation } from "react-router-dom";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { BottomMenu } from "./BottomMenu";
import { HeaderBar } from "./HeaderBar";

interface HelpWidgetContainerProps {
  children: React.ReactNode;
  onClose: () => void;
  pageName: string;
}

export const HelpWidgetContainer = ({
  children,
  onClose,
  pageName,
}: HelpWidgetContainerProps) => {
  const { isExpanded, isShowingLeaveWarning } = useHelpWidgetContext();
  const location = useLocation();
  const path = location.pathname;

  const isBottomMenuVisible =
    !path.match(/^\/conversations\/\d+$/) &&
    !path.endsWith("/new_ticket") &&
    !path.startsWith("/message_confirmation/");

  const isHeaderBarVisible = !isShowingLeaveWarning;

  const isHomePage =
    path === "/" ||
    path.endsWith("/new_ticket") ||
    path.startsWith("/message_confirmation/");

  const isGradientVisible = path === "/";

  return (
    <div
      className={classNames("flex flex-col rounded-2xl bg-white", {
        "h-[732px]": !isExpanded,
        "h-[calc(100vh-16px)]": isExpanded,
      })}
      style={{
        border: "4px solid rgba(228, 231, 235, 0.4)",
        boxShadow: `
        8px 14px 35px 0px rgba(110, 110, 110, 0.07),
        32px 54px 63px 0px rgba(110, 110, 110, 0.06),
        71px 122px 85px 0px rgba(110, 110, 110, 0.03),
        126px 218px 101px 0px rgba(110, 110, 110, 0.01),
        197px 340px 110px 0px rgba(110, 110, 110, 0)
      `,
        transition: "height 300ms ease 0s",
      }}
    >
      {isGradientVisible && (
        <div className="relative left-0 top-0 w-96 opacity-10">
          <div className="absolute left-[27.06px] top-[474.84px] h-60 w-72 rounded-full bg-violet-600 blur-[106px]" />
          <div className="absolute left-[51.36px] top-[420px] h-44 w-56 rounded-full bg-rose-500 blur-[106px]" />
          <div className="absolute left-[156.85px] top-[494.50px] h-48 w-60 rounded-full bg-sky-200 blur-[106px]" />
          <div className="absolute left-0 top-[471.02px] h-32 w-28 rounded-full bg-sky-400 blur-[106px]" />
        </div>
      )}
      <div
        className={classNames(
          "relative hidden h-full min-w-[400px] origin-bottom-right overflow-hidden rounded-t-2xl lg:flex lg:flex-col",
          {
            "border-b border-b-[#E4E7EB]": isBottomMenuVisible && !isHomePage,
          },
        )}
        style={{
          transition:
            "width 300ms ease 0s, transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s",
        }}
      >
        <div className="relative z-10 flex h-full w-full flex-col">
          {isHeaderBarVisible && (
            <HeaderBar pageName={pageName} onClose={onClose} />
          )}
          {children}
        </div>
      </div>
      {isBottomMenuVisible && (
        <div className="border-primary hidden h-[66px] origin-bottom-right rounded-b-2xl bg-white shadow-lg lg:flex">
          <BottomMenu />
        </div>
      )}
    </div>
  );
};
